import React from "react"
import "./instructionsPure.css";

/**
 * @typedef {Object} Props
 * @property {Array<String>} instructions Las instrucciones se mostrarán separadas por un salto de línea <br />
 * ```js
 * let instructions = ['Formato de la imagen': 'Tipo jpg']
 * @param {Props}
 * @return {JSX.Element} 
 */
const InstructionsPure = ({ instructions }) => {
    return (
        <div className="instructionsPure-container">
            {Array.isArray(instructions)
                ? instructions.map(instruction => <p className="instructionsPure-instructions">{instruction}</p>)
                : <p className="instructionsPure-instructions">{instructions}</p>
            }
        </div>
    )
}

export { InstructionsPure as default }
